import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';

export type AircallOauthCode = {
  code: string;
};

const aircallAuthCallback = (data: AircallOauthCode) => {
  const request: Request = {
    url: ENDPOINTS.aircall.authCallback,
    config: {
      method: 'post',
      data: data,
    },
  };

  return client(request);
};

const useAircallAuthCallback = () =>
  useMutation<Response<null>, CronoError, AircallOauthCode>(
    aircallAuthCallback,
    {
      meta: {
        successMessage: 'Successfully logged into Aircall',
        errorMessage: 'Error while connecting with Aircall',
      },
    },
  );

export default useAircallAuthCallback;
